<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :disabled="props.disabled"
    @submit="handelSubmit"
    submitText="审批"
    ref="formRef"
  >
    <template #approval>
      <h4>审批流程</h4>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
    </template>
  </multiple_form>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/car_application/car_registration_approval'
  import multiple_form from '@/components/multiple_form'
  import { blackWhiteListType, resultOptions } from '@/utils/common'
  import { approvalProcess } from '@/api/car_application/car_registration'
  import { constantToOptions } from '@/utils/format'
  import approval_process_content from '@/components/approval_process_content'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    taskId: String,
    disabled: { type: Boolean, default: false },
    modifyVisitTime: { type: Boolean, default: false },
  })
  const emit = defineEmits(['submit'])
  const formRef = ref()
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '基础信息',
      id: 'applicant_information',
      // dataInObject: 'vehicleRegistration',
      formItem: [

        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
          defaultValue: props.editData?.visitor_company || ''
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
          defaultValue: props.editData?.license_plate || ''
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
          required: false,
          defaultValue: props.editData?.license_plate_color || null
        },
        {
          type: 'dateRange',
          startField: 'begin_time',
          endField: 'end_time',
          label: '来访时间',
          defaultValue: [props.editData?.begin_time, props.vehicleDetail?.end_time]
        },
        {
          type: 'input',
          field: 'phone',
          label: '手机号码',
          defaultValue: props.editData?.phone || ''
        },
      ],
    },
    {
      name: '相关文件',
      id: 'applicant_file',
      // dataInObject: 'vehicleRegistration',
      formItem: [
        {
          type: 'image',
          field: 'registry_img',
          label: '车辆信息登记表',
          // required: false,
          // defaultValue: props.editData?.registry_img || []
        },
        {
          type: 'image',
          field: 'business_license',
          label: '营业执照复印件',
          // required: false,
          // defaultValue: props.editData?.business_license || []
        },
        {
          type: 'image',
          field: 'company_road_transport_img',
          label: '公司道路运输经营许可证复印件',
          // required: false,
          // defaultValue: props.editData?.company_road_transport_img || []
        },
        {
          type: 'image',
          field: 'legal_person_img',
          label: '法人身份证',
          // required: false,
          // defaultValue: props.editData?.legal_person_img || []
        },
        {
          type: 'image',
          field: 'driver_info_img',
          label: '驾驶员的驾驶证、身份证及从业资格证',
          // required: false,
          // defaultValue: props.editData?.driver_info_img || []
        },
        {
          type: 'image',
          field: 'supercargo_info_img',
          label: '押运员的身份证以及从业资格证',
          // required: false,
          // defaultValue: props.editData?.supercargo_info_img || []
        },
        {
          type: 'image',
          field: 'vehicle_driving_permit_img',
          label: '行驶证（车头、挂车）',
          // required: false,
          // defaultValue: props.editData?.vehicle_driving_permit_img || []
        },
        {
          type: 'image',
          field: 'road_transport_img',
          label: '道路运输证（车头、挂车）',
          // required: false,
          // defaultValue: props.editData?.road_transport_img || []
        },
        {
          type: 'image',
          field: 'compulsory_insurance_img',
          label: '强制险',
          // required: false,
          // defaultValue: props.editData?.compulsory_insurance_img || []
        },
        {
          type: 'image',
          field: 'commercial_insurance_img',
          label: '商业险',
          // required: false,
          // defaultValue: props.editData?.commercial_insurance_img || []
        },
        {
          type: 'image',
          field: 'carrier_liability_insurance_img',
          label: '道路危险货物承运人责任保险',
          // required: false,
          // defaultValue: props.editData?.carrier_liability_insurance_img || []
        },
        {
          type: 'image',
          field: 'report_or_instruction_img',
          label: '罐检报告或产品图片、产品标签图片以及车尾照片',
          // required: false,
          // defaultValue: props.editData?.report_or_instruction_img || []
        },
        {
          type: 'image',
          field: 'letter_commitment_img',
          label: '重点运输单位承诺书',
          // required: false,
          // defaultValue: props.editData?.letter_commitment_img || []
        },
        {
          // type: 'fileUpload',
          type: 'image',
          field: 'gps_instruction_img',
          label: 'GPS接入文档',
          number: 20,
          // required: false,
          // defaultValue: props.editData?.gps_instruction_img || []
        },
      ],
    },
    {
      name: '审批信息',
      id: 'approval',
      formItem: [
        {
          type: 'radio',
          field: 'result',
          label: '审批结果',
          defaultValue: 1,
          options: constantToOptions(resultOptions),
          disabled: false,
          onChange: (val) => {
            if (
              formRef.value &&
              formRef.value.formRefs &&
              formRef.value.formRefs.approval &&
              formRef.value.formRefs.approval.formState
            ) {
              // formRef.value.formRefs.approval.formState.remark = val.target.value === '1' ? '审批通过。' : '审批不通过。'
              formRef.value.formRefs.approval.formState.remark = val.target.value === '1' ? '审批通过。' : ''
            }
          }
        },
        {
          type: 'textarea',
          field: 'remark',
          label: '审批意见',
          defaultValue: '审批通过。',
          disabled: false
        }
      ]
    }
  ])
  async function handelSubmit(data) {
    const messageText = '审核'

    const res = await approval({
      ...data,
      // taskIds: props.editData[props.idField],
      'taskIds': props.taskId,
    })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
  const approvalProcessData = ref()
  if (props.editData?.id) {
    getApprovalProcess()
  }
  async function getApprovalProcess() {
    const res = await approvalProcess({ id: props.editData.id })
    approvalProcessData.value = res.data
  }
</script>
